<style>
h4 {
  text-transform: initial !important;
}
h5 {
  text-transform: none !important;
}

.dropdown {
  cursor: pointer;
  display: flex;
  justify-content: flex-end;
}
.btn-secondary .dropdown-toggle {
  color: #045C68 !important;
  background-color: #e2e6ea !important;
  border-color: #ECECEC !important;
  min-width: 15%;
  border-radius: 5px !important;
}
.btn-secondary {
  color: #045C68;
  background-color: #f8f9fa;
  border-color: #ECECEC !important;
  border-radius: 5px !important;
  margin: 15px 5px;
  min-width: 15%;
  text-transform: uppercase;
  font-size: 15px;
  padding: 14px;
  font-family: sans-serif !important;
  transition: 0.5s ease-in-out;
}

.show > .btn-secondary.dropdown-toggle {
  background-color: #045C68;
}

.form-check-label {
  cursor: pointer !important;
}

.dropdown-menu {
  min-width: 20%;
}
.card-header {
  padding: 0.75rem 1.25rem;
  margin-bottom: 0;
  background-color: transparent;
  border-bottom: none !important;
}

.resmed-h5 {
  text-align: center;
  font-size: 1.2em;
}

.card {
  border: none !important;
}

.text-center {
  padding: 2%;
}

.col-md-3 {
  flex: 0 0 25%;
  max-width: 25%;
}

@media only screen and (max-width: 1000px) {
  .col-md-3 {
    flex: 0 0 50%;
    max-width: 50%;
  }
}

@media only screen and (max-width: 600px) {
  .col-md-3 {
    flex: 0 0 100%;
    max-width: 100%;
  }
}
</style>

<template>
  <div id="BathSafety-view">
    <head>
      <meta
        name="description"
        content="Explore ResMed's top-rated CPAP masks for effective sleep apnea therapy, ensuring comfort, quiet operation, and a perfect fit."
      />
    </head>
    <section class="bg-light ftco-section">
      <div class="container" style="min-width: 90vw">
        <h1 class="display-4 text-center my-4">
          RESMED CPAP MASKS<br />
          <Span style="font-size: 0.3em">(prescription required)</Span>
        </h1>
        <p class="text-center">
          Discover the unparalleled comfort and performance of ResMed CPAP
          masks, meticulously designed to provide effective sleep apnea therapy.
          Our extensive range of ResMed masks caters to diverse needs and
          preferences, ensuring a perfect fit for every user. Explore our
          top-rated full face, nasal, and nasal pillow masks, all embedded with
          advanced features to enhance your sleep therapy experience. ResMed’s
          innovative technology ensures quiet operation, minimal air leakage,
          and optimal pressure delivery, guaranteeing a restful night’s sleep.
          <br><br>For your health and safety, all ResMed masks require a prescription for purchase. 
          Click <a href="/cpapform" target="_blank">here</a> to explore our mask selection and complete your submission. <br>
          If you need any further assistance, our customer support is ready to help.
        </p>
        <div id="filters">
          <div class="dropdown">
            <button
              class="btn btn-secondary dropdown-toggle"
              type="button"
              id="refineDropdown"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              Filter By
            </button>
            <div class="dropdown-menu" aria-labelledby="refineDropdown">
              <!-- Gender Filter -->
              <div class="form-check px-4">
                <input
                  class="form-check-input"
                  type="checkbox"
                  value="Male"
                  v-model="filters.gender"
                  id="maleCheck"
                />
                <label class="form-check-label" for="maleCheck">
                  Universal
                </label>
              </div>
              <div class="form-check px-4">
                <input
                  class="form-check-input"
                  type="checkbox"
                  value="Female"
                  v-model="filters.gender"
                  id="femaleCheck"
                />
                <label class="form-check-label" for="femaleCheck">
                  For Her
                </label>
              </div>
              <!-- Divider -->
              <div class="dropdown-divider"></div>

              <!-- Mask Type Filter -->
              <div class="form-check px-4">
                <input
                  class="form-check-input"
                  type="checkbox"
                  value="Full Face"
                  v-model="filters.maskType"
                  id="fullFaceCheck"
                />
                <label class="form-check-label" for="fullFaceCheck">
                  Full Face Mask
                </label>
              </div>
              <div class="form-check px-4">
                <input
                  class="form-check-input"
                  type="checkbox"
                  value="Pillow"
                  v-model="filters.maskType"
                  id="pillowCheck"
                />
                <label class="form-check-label" for="fullFaceCheck">
                  Pillow Mask
                </label>
              </div>
              <div class="form-check px-4">
                <input
                  class="form-check-input"
                  type="checkbox"
                  value="Nasal"
                  v-model="filters.maskType"
                  id="nasalCheck"
                />
                <label class="form-check-label" for="nasalCheck">
                  Nasal Mask
                </label>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div
            class="col-md-3"
            v-for="product in filteredProducts"
            :key="product.id"
          >
            <div class="card">
              <div class="card-header">
                <router-link :to="product.linkto">
                <img
                  :src="product.imageUrl"
                  class="img-fluid"
                  :alt="product.title"
                />
              </router-link>
                <div class="card-sub">
                  <h5 class="resmed-h5">{{ product.title }}</h5>
                </div>
              </div>
              <div class="card-body mt-0 pt-0">
                <div class="text-black">
                  <ul>
                    <li v-for="detail in product.details" :key="detail">
                      {{ detail }}
                    </li>
                    <div class="collapse" :id="'moreInfo' + product.id">
                      <li
                        v-for="moreDetail in product.moreDetails"
                        :key="moreDetail"
                      >
                        {{ moreDetail }}
                      </li>
                    </div>
                  </ul>
                </div>
                <a
                  :class="{ collapsed: !product.showMore }"
                  data-toggle="collapse"
                  @click="toggleText(product.id)"
                  :href="'#moreInfo' + product.id"
                  role="button"
                  aria-expanded="false"
                  :aria-controls="'moreInfo' + product.id"
                >
                  {{ product.showMore ? "Show Less" : "Show More" }}
                </a>
              </div>
              <div id="action-buttons" class="d-flex justify-content-between">
                <router-link
                  :to="product.linkto"
                  class="btn btn-light mt-3"
                  style="white-space: normal; font-size: 13px !important"
                  tag="button"
                >
                  View Details
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <h1 class="display-4 text-center my-4">
        RESMED CPAP MACHINES<br />
          <Span style="font-size: 0.3em">(prescription required)</Span>
        </h1>
        <p class="text-center">
          Experience the transformative quality of our CPAP machines, expertly crafted to revolutionize your sleep apnea therapy. Our comprehensive lineup includes the industry-leading ResMed machines, tailored to meet the individual requirements and comfort levels of each user. Delve into our selection of cutting-edge, user-friendly CPAP and APAP machines, all designed to deliver precise therapy pressure, ensuring an uninterrupted, restful night's sleep. Each device is equipped with the latest technology for seamless operation, minimal noise, and maximum efficiency.
          <br><br>For your health and safety, purchasing a CPAP machine requires a prescription. 
          Click <a href="/cpapform" target="_blank">here</a>  view our range of machines and initiate your order.<br>
          If you need any further assistance, our customer support is ready to help.
        </p>
      <div class="container ">
        <div class="row" style="justify-content: center;">
          <div class="col-md-6">
          <div class="card">
          <div class="card-header">
            <img src="@/assets/site/CPAP/AirSense/1.webp" class="img-fluid" alt />
            <div class="card-sub">
                 <h5> AirSense 10 Series</h5>
                 </div>
                </div>
          <div class="card-body mt-0 pt-0">
          <div class="text-black">
            AirSense™ 10 is the world’s most widely used series of CPAP and APAP machines, each designed to deliver high-quality therapy for a better night’s sleep...
              <a href="/airsense" class="" target="_blank">more info</a>
            </div>
            <div id="action-buttons" class="d-flex justify-content-between">
           <a href="/airsense" id="purchaseInsurance" class="btn btn-light mt-3" style="white-space: normal; font-size: 13px !important;" target="_blank"> 
           View Details <br>
           </a>
          </div>
        </div>
         </div>
        </div>
        </div>
      </div>

    </section>

    <section class="bg-light ftco-section1"></section>

    <div
      class="containerfluid text-center d-flex align-items-baseline"
      style="position: absolute"
    >
      <div class="row">
        <div class="col-md-6 d-flex justify-content-start">
          <img
            src="@/assets/site/images/leaf.webp"
            alt
            class="img-fluid"
            style="width: 55%"
          />
        </div>
        <div class="col-md-6 d-flex justify-content-end">
          <img
            src="@/assets/site/images/flower-3.webp"
            alt
            class="img-fluid"
            style="width: 55%"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      products: [
        {
          id: 1,
          showMore: false,
          title: "AirFit F20 Full Face Mask",
          imageUrl: require("@/assets/site/CPAP/1.webp"),
          details: [
            "Universal Fit category",
            "Full face mask",
            "Mouth and nose coverage",
            "Silicone cushion",
          ],
          moreDetails: [
            "The Perfect, Secure Seal Full Face CPAP",
            "Improving Nasal Bridge Comfort",
            "Contoured Chin Design",
            "Frosted Silicone Cushion",
            "Replace Cushion Without Replacing",
          ],
          linkto: "/resmed-air-fit-f20",
          gender: "Male",
          maskType: "Full Face",
        },
      
        {
          id: 2,
          showMore: false,
          title: "AirFit F20 Full Face For Her Mask",
          imageUrl: require("@/assets/site/CPAP/2.webp"),
          details: [
            "Universal Fit category",
            "Mouth and nose coverage",
            "Contoured Chin Design",
            "The Perfect",
          ],
          moreDetails: [
            "Secure Seal Full Face CPAP",
            "Improving Nasal Bridge Comfort",
            "Silicone cushion",
            "The Perfect, Secure Seal Full Face CPAP",
            "Frosted Silicone Cushion",
            "Replace Cushion Without Replacing ",
          ],
          linkto: "/airfitf20fullfacemaskforher",
          gender: "Female",
          maskType: "Full Face",
        },
        {
          id: 3,
          showMore: false,
          title: "AirFit F10 Full Face Mask",
          imageUrl: require("@/assets/site/CPAP/3.webp"),
          details: [
            "Secure seal",
            "Easy remove mask design",
            "Quiet diffused air venting",
            "Easy to clean",
          ],
          moreDetails: ["Spring Air Cushion"],
          linkto: "/airfitf10fullfacemask",
          gender: "Male",
          maskType: "Full Face",
        },
        {
          id: 4,
          showMore: false,
          title: "AirFit F10 Full Face for Her Mask",
          imageUrl: require("@/assets/site/CPAP/4.webp"),
          details: [
            "Minimal Contact on Face",
            "Easy remove mask design",
            "Quiet diffused air venting",
            "The Perfect",
          ],
          moreDetails: [
            "Secure seal for lasting performance all night",
            "Offers Minimal Contact on Face and Easy Assembly",
            "Dual–Wall Cushion Provides Double the Benefits",
            "Pick Your Fit on Your Pink–Hued Headgear with Adjustable Feature",
            "Fewer Materials Adds Up to an Open View for T.V. Watching",
            "Circular Vent at Quick–Release Elbow Quiets Your Night",
          ],
          linkto: "/airfitf10fullfacemaskforher",
          gender: "Female",
          maskType: "Full Face",
        },

        // other Products
        {
          id: 5,
          showMore: false,
          title: "AirFit F30 Full Face Mask",
          imageUrl: require("@/assets/site/CPAP/5.webp"),
          details: [
            "Minimalist category",
            "Mouth and nose coverage",
            "Full face mask",
            "Silicone cushion",
          ],
          moreDetails: [
            "Lightweight design",
            "It's an upgrade from older models with low profile style",
            "Fewer pressure points with AirFit F30 Cushion",
            "Headgear is not bulky",
            "Easy to Adjust Headgear",
            "Comfortable for Side Sleepers",
          ],
          linkto: "/airfitf30fullfacemask",
          gender: "Male",
          maskType: "Full Face",
        },
        {
          id: 6,
          showMore: false,
          title: "AirFit F30i Full Face Mask",
          imageUrl: require("@/assets/site/CPAP/6.webp"),
          details: [
            "Freedom category",
            "Mouth and nose coverage",
            "Full face mask",
            "Silicone cushion",
          ],
          moreDetails: [
            "Ultra-Compact Silicone Cushion Provides a Reliable Seal",
            "360 Degree Swivel and Top-of-Head Connection",
            "Click Fit Headgear for Easy Adjustment",
            "Magnetic Headgear Clips and Quick-Release Elbow",
            "Lightweight Hollow Headgear",
            "Quiet-Vent Technology",
          ],
          linkto: "/airfitf30ifullfacemask",
          gender: "Male",
          maskType: "Full Face",
        },
        {
          id: 7,
          showMore: false,
          title: "AirFit N20 Nasal Mask",
          imageUrl: require("@/assets/site/CPAP/7.webp"),
          details: [
            "Universal Fit category",
            "Nose coverage",
            "Nasal mask",
            "Silicone cushion",
          ],
          moreDetails: [
            "Infinity Seal’s pliable silicone cushion will secure safely to most face shapes",
            "By minimizing facial contacts the soft pad frame avoids creating facial marks",
            "For easy and fast hose disconnection, a quick release elbow is used.",
            "The low profile design allows for clear vision",
            "For support and comfort, plush headgear is used",
          ],
          linkto: "/airfitn20nasalmask",
          gender: "Male",
          maskType: "Nasal",
        },
        {
          id: 8,
          showMore: false,
          title: "AirFit N20 Nasal for Her Mask",
          imageUrl: require("@/assets/site/CPAP/8.webp"),
          details: [
            "Universal Fit category",
            "Nose coverage",
            "Nasal mask",
            "Silicone cushion",
          ],
          moreDetails: [
            "Infinity Seal’s pliable silicone cushion will secure safely to most face shapes",
            "By minimizing facial contacts, the soft pad frame avoids creating facial marks",
            "For easy and fast hose disconnection, a quick release elbow is used",
            "The low profile design allows for clear vision",
            "For easy adjustment, magnetic clips are used",
            "For support and comfort, plush headgear is used",
          ],
          linkto: "/airfitn20nasalmaskforher",
          gender: "Female",
          maskType: "Nasal",
        },
        {
          id: 9,
          showMore: false,
          title: "AirFit P30i Nasal Mask",
          imageUrl: require("@/assets/site/CPAP/9.webp"),
          details: [
            "Freedom category",
            "Nose coverage",
            "Nasal mask",
            "Silicone cushion",
          ],
          moreDetails: [
            "Top-of-head connection keeps air tubing out of your way for more freedom",
            "QuietAir™ vent reduces sound to only 21 decibels – quieter than a soft whisper",
            "Nearly 4 out of 5 CPAP users find it provides an excellent seal",
            "Quick-release elbow allows you to get up at night and disconnect without removing the mask",
          ],
          linkto: "/airfitp30inasalmask",
          gender: "Male",
          maskType: "Nasal",
        },

        {
          id: 10,
          showMore: false,
          title: "AirFit P10 Nasal Pillow Mask",
          imageUrl: require("@/assets/site/CPAP/10.webp"),
          details: [
            "Minimalist category",
            "Nose coverage",
            "Nasal pillows mask",
            "Silicone cushion",
          ],
          moreDetails: [
            "NEW! Headgear Side Clip for Easy Adjustments*",
            "Stable Seal With Comfort in Mind",
            "Fewer Facial Touchpoints",
            "Pliable, Lightweight, and Durable Tube",
            "Customize Your Fit: Includes Small, Medium, and Large Nasal Pillows",
            "Flexible and Comfortable QuickFit Headgear",
            "50% Lighter and Quieter Than Other Nasal Pillows on the Market",
          ],
          linkto: "/airfitp10nasalpillowmask",
          gender: "Male",
          maskType: "Pillow",
        },
        {
          id: 11,
          showMore: false,
          title: "AirTouch F20 Full Face Mask",
          imageUrl: require("@/assets/site/CPAP/11.webp"),
          details: [
            "Ultra Soft category",
            "Mouth and nose coverage",
            "Full face mask",
            "Memory foam cushion",
          ],
          moreDetails: [
            "Slim straps are lightweight and breathable with magnetic clips",
            "Plush fabric for extra softness",
            "Compatible with both AirFit F20s and AirTouch F20s",
          ],
          linkto: "/airtouchf20fullfacemask",
          gender: "Male",
          maskType: "Full Face",
        },
        {
          id: 12,
          showMore: false,
          title: "Swift FX For Her Nasal Pillow Mask",
          imageUrl: require("@/assets/site/CPAP/12.webp"),
          details: [
            "Dual-wall nasal pillow",
            "Unique FX system",
            "Flexible chamber",
            "Easy to clean",
          ],
          moreDetails: [
            "Maintains a Consistent Seal Even at High Therapy Pressures",
            "Minimal Design Creates Ergonomic Comfort",
            "Easy to Find Your Right Fit",
            "Leading in Innovation for Headgear",
            "The Perfect Ultra-Quiet Solution for Light Sleepers",
          ],
          linkto: "/swiftfxforhernasalpillow",
          gender: "Female",
          maskType: "Pillow",
        },

        {
          id: 13,
          showMore: false,
          title: "Swift FX Nasal Pillow Mask",
          imageUrl: require("@/assets/site/CPAP/13.webp"),
          details: [
            "Enhanced nose bridge comfort",
            "Minimal facial contact headgear",
            "High performance diffused air venting",
            "Secure seal",
          ],
          moreDetails: [
            "Maintains a Consistent Seal Even at High Therapy Pressures",
            "Minimal Design Creates Ergonomic Comfort",
            "Easy to Find Your Right Fit",
            "Leading in Innovation for Headgear",
            "The Perfect Ultra-Quiet Solution for Light Sleepers",
          ],
          linkto: "/swiftfxnasalpillowmask",
          gender: "Male",
          maskType: "Pillow",
        },

        {
          id: 14,
          showMore: false,
          title: "Quattro Air for Her Full Face Mask",
          imageUrl: require("@/assets/site/CPAP/14.webp"),
          details: [
            "Easy Cleaning",
            "Open Line of Sight",
            "SoftEdge Headgear Features",
            "Easy to clean",
          ],
          moreDetails: [
            "Easy-to-Use Design and Easy Cleaning",
            "Spring Air Cushion Offers Comfort and Strengthens Seal",
            "SoftEdge Headgear Features Feminine Touches",
            "Quick Release Elbow and Circular Vent Permit Movement and Reduce Noise",
          ],
          linkto: "/quattroairforherfullfacemask",
          gender: "Female",
          maskType: "Full Face",
        },
        {
          id: 15,
          showMore: false,
          title: "Quattro FX for Her Full Face Mask",
          imageUrl: require("@/assets/site/CPAP/15.webp"),
          details: [
            "Enhanced nose bridge comfort",
            "Minimal facial contact headgear",
            "High performance diffused air venting",
            "Perfect Fit",
          ],
          moreDetails: [
            "Spring Air Cushion Enhances Your Seal and Limits Skin Irritation",
            "Fewer Facial Touchpoints and Open Line of Sight",
            "Swing Technique and Gentle Inflation to Find Your Fit",
          ],
          linkto: "/quattrofxforherfullfacemask",
          gender: "Female",
          maskType: "Full Face",
        },
        {
          id: 16,
          showMore: false,
          title: "Mirage FX Nasal Mask",
          imageUrl: require("@/assets/site/CPAP/16.webp"),
          details: [
            "Light-wear frame",
            "Unique butterfly-wing",
            "Spring Air cushion",
            "Quick-release elbow",
          ],
          moreDetails: [
            "Only four parts make wear and care easy!",
            "The slender and ultra lightweight frame provide an open field of vision and stable fit",
            'The flexible "butterfly wing" forehead support allows a dynamic range of fit and adjustment; the plastic does not contact the skin',
            "Dual-wall Spring Air cushion provides extra softness at the nasal bridge",
            "The Squeeze-tab elbow lets you quickly detach your tubing at the mask for easy removal",
          ],
          linkto: "/miragefxnasalmask",
          gender: "Male",
          maskType: "Nasal",
        },
        {
          id: 17,
          showMore: false,
          title: "Mirage Quattro Full Face Mask",
          imageUrl: require("@/assets/site/CPAP/17.webp"),
          details: [
            "Minimal facial contact headgear",
            "High performance diffused air venting",
            "Adapts to Jaw Drop",
            "Secure seal",
          ],
          moreDetails: [
            "Secure, Contoured Seal",
            "Includes Guides for Easy Use",
            "Adjustable and Easy to Use",
            "The Perfect Ultra-Quiet  for Light Sleepers",
          ],
          linkto: "/miragequattrofullfacemask",
          gender: "Male",
          maskType: "Full Face",
        },
        {
          id: 18,
          showMore: false,
          title: "AirFit N30 Nasal Mask",
          imageUrl: require("@/assets/site/CPAP/18.webp"),
          details: [
            "Freedom category",
            "Nose coverage",
            "Nasal mask",
            "Silicone cushion",
          ],
          moreDetails: ["Under the nose nasal cradle cushion"],
          linkto: "/airfitn30nasalmask",
          gender: "Male",
          maskType: "Nasal",
        },

        {
          id: 19,
          showMore: false,
          title: "AirFit N30i Nasal Mask",
          imageUrl: require("@/assets/site/CPAP/19.webp"),
          details: [
            "Freedom category",
            "Nose coverage",
            "Nasal mask",
            "Silicone cushion",
          ],
          moreDetails: ["Under the nose nasal cradle cushion"],
          linkto: "/airfitn30inasalmask",
          gender: "Male",
          maskType: "Nasal",
        },

        {
          id: 20,
          showMore: false,
          title: "AirFit P30i Nasal Pillows Mask",
          imageUrl: require("@/assets/site/CPAP/20.webp"),
          details: [
            "Minimal facial contact headgear",
            "High performance diffused air venting",
            "Secure seal",
            "Universal frame",
          ],
          moreDetails: [
            "Top-of-head connection keeps air tubing out of your way for more freedom",
            "QuietAir™ vent reduces sound to only 21 decibels – quieter than a soft whisper",
            "Nearly 4 out of 5 CPAP users find it provides an excellent seal",
            "Quick-release elbow allows you to get up at night and disconnect without removing the mask",
          ],
          linkto: "/resmedairfitp30inasalpillowmask",
          gender: "Male",
          maskType: "Pillow",
        },

        {
          id: 21,
          showMore: false,
          title: "Airtouch N20 Nasal Mask",
          imageUrl: require("@/assets/site/CPAP/21.webp"),
          details: [
            "Light-wear frame",
            "Unique butterfly-wing",
            "Spring Air cushion",
            "Quick-release elbow",
          ],
          moreDetails: [
            "UltraSoft memory foam cushion is uniquely comfortable",
            "Magnetic clips mean two simple snaps and your mask is on or off",
            "Quick-release elbow allows you to get up at night and disconnect without removing the mask",
            "Minimal cleaning requirements give you time back in the morning",
            "Available in a for Her version, which features lavender accents rather than blue, and is only available in size Small",
            "The mask frame is designed to also work with the ResMed AirFit™ N20 silicone cushion",
          ],
          linkto: "/airtouchn20nasalmask",
          gender: "Male",
          maskType: "Nasal",
        },
      ],
      filters: {
        gender: [],
        maskType: [],
      },
    };
  },
  computed: {
    filteredProducts() {
      return this.products.filter((product) => {
        const genderFilter =
          this.filters.gender.length === 0 ||
          this.filters.gender.includes(product.gender);

        const maskTypeFilter =
          this.filters.maskType.length === 0 ||
          this.filters.maskType.includes(product.maskType);

        return genderFilter && maskTypeFilter;
      });
    },
  },
  methods: {
    toggleText(productId) {
      const product = this.products.find((p) => p.id === productId);
      if (product) product.showMore = !product.showMore;
    },
  },
};
</script>
